import { render } from "./EditClaimEvent.vue?vue&type=template&id=a36a068e&scoped=true"
import script from "./EditClaimEvent.vue?vue&type=script&lang=js"
export * from "./EditClaimEvent.vue?vue&type=script&lang=js"

import "./save-claim-event.scss?vue&type=style&index=0&id=a36a068e&lang=scss&scoped=true"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a36a068e"]])

export default __exports__